import { useEffect, useState } from "react";
import { api } from "../lib/api";
import AppShell from "../components/AppShell";
import StatusBadge from "../components/StatusBadge";
import { formatINR } from "../lib/utils-format";
import { toast } from "sonner";
import { Play, Loader2 } from "lucide-react";

export default function AdminPairing() {
    const [runs, setRuns] = useState([]);
    const [loading, setLoading] = useState(false);

    const load = async () => {
        const { data } = await api.get("/pairing/admin/runs");
        setRuns(data);
    };
    useEffect(() => { load(); }, []);

    const run = async () => {
        setLoading(true);
        try {
            await api.post("/pairing/admin/run");
            toast.success("Pairing run complete");
            load();
        } catch (e) {
            toast.error(e.response?.data?.detail || "Failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <AppShell admin>
            <div className="mb-6 flex items-center justify-between">
                <div>
                    <div className="overline">Admin</div>
                    <h1 className="font-display font-black text-3xl tracking-tighter text-slate-900 mt-2">Pairing job runs</h1>
                </div>
                <button
                    onClick={run}
                    disabled={loading}
                    data-testid="admin-pairing-run-btn"
                    className="h-10 px-4 rounded-lg bg-[#2563EB] hover:bg-[#1D4ED8] text-white text-sm font-semibold flex items-center gap-2 disabled:opacity-70"
                >
                    {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Play className="w-4 h-4" />}
                    Run now
                </button>
            </div>

            <div className="stat-card overflow-x-auto">
                <table className="w-full text-sm">
                    <thead>
                        <tr className="bg-gradient-to-r from-[#1B2B6B] to-[#2A3D82] text-white">
                            <th className="text-left font-semibold py-3 px-2 text-xs uppercase tracking-wider">Date</th>
                            <th className="text-left font-semibold py-3 px-2 text-xs uppercase tracking-wider">Status</th>
                            <th className="text-center font-semibold py-3 px-2 text-xs uppercase tracking-wider">Users</th>
                            <th className="text-center font-semibold py-3 px-2 text-xs uppercase tracking-wider">Pairs</th>
                            <th className="text-right font-semibold py-3 px-2 text-xs uppercase tracking-wider">Net paid</th>
                            <th className="text-right font-semibold py-3 px-2 text-xs uppercase tracking-wider">Deduction</th>
                            <th className="text-left font-semibold py-3 px-2 text-xs uppercase tracking-wider">Started</th>
                        </tr>
                    </thead>
                    <tbody>
                        {runs.length === 0 && <tr><td colSpan={7} className="text-center py-8 text-slate-500">No runs yet.</td></tr>}
                        {runs.map((r) => (
                            <tr key={r.id} className="border-b border-slate-100" data-testid={`pairing-run-${r.id}`}>
                                <td className="py-3 px-2 font-mono">{r.run_date}</td>
                                <td className="py-3 px-2"><StatusBadge status={r.status} /></td>
                                <td className="py-3 px-2 text-center">{r.users_processed}</td>
                                <td className="py-3 px-2 text-center font-bold">{r.pairs_credited}</td>
                                <td className="py-3 px-2 text-right font-mono text-[#2563EB]">{formatINR(r.total_net)}</td>
                                <td className="py-3 px-2 text-right font-mono text-red-600">{formatINR(r.total_deduction)}</td>
                                <td className="py-3 px-2 text-xs text-slate-500">{new Date(r.started_at).toLocaleString()}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </AppShell>
    );
}
